export const getBadgesListRoute = (): string => {
  return `/space/badges`;
};

export const getHomepageRoute = (): string => {
  return '/';
};

export const getStoreNotFoundRoute = (): string => {
  return '/store/not-found';
};

export const getDefaultLoginRoute = (): string => {
  return '/login';
};

export const getMerchantSpaceLoginRoute = (): string => {
  return `/space/login`;
};

export const getMerchantSpaceRoute = (): string => {
  return `/space/home`;
};

export const getOwnershipDetailRoute = (ownershipId: string): string => {
  return `/space/rewards/ownerships/${ownershipId}`;
};

export const getImportNftRoute = (): string => {
  return `/space/rewards/ownerships/imports/new`;
};

export const getPerkDetailRoute = (perkId: string): string => {
  return `/space/rewards/perks/${perkId}`;
};

export const getPerkUsageRoute = (perkId: string, perkAccessId: string): string => {
  return `/space/rewards/perks/${perkId}/perk-accesses/${perkAccessId}/use`;
};

export const getNftTransferInvitationLoginRoute = (nfTransferInvitationId: string): string => {
  return `/space/invitations/${nfTransferInvitationId}/login`;
};

export const getNftTransferInvitationRoute = (nfTransferInvitationId: string): string => {
  return `/space/invitations/${nfTransferInvitationId}`;
};

export const getNewNftTransferRoute = (ownershipId: string): string => {
  return `/space/rewards/ownerships/${ownershipId}/transfer/new`;
};

export const getJourneysListRoute = (): string => {
  return `/space/journeys`;
};

export const getJourneyDetailRoute = (journeyId: string): string => {
  return `/space/journeys/${journeyId}`;
};

export const getJourneyTriggerIntegrationUsageRoute = (
  journeyId: string,
  stepId: string,
  triggerId: string
): string => {
  return `/space/journeys/${journeyId}/steps/${stepId}/triggers/${triggerId}/use`;
};

export const getRewardsListRoute = (filter?: 'perks' | 'digital-assets'): string => {
  return `/space/rewards${filter ? `?filter=${filter}` : ''}`;
};

export const getSpaceSettingsRoute = (): string => {
  return `/space/settings`;
};

export const getRootPaths = (campaignSlug?: string): string[] => {
  return [
    getMerchantSpaceRoute(),
    getJourneysListRoute(),
    getRewardsListRoute(),
    getSpaceSettingsRoute(),
    ...(campaignSlug ? [getStoreCampaignRoute(campaignSlug)] : []),
  ];
};

export const getStoreLoginRoute = (campaignSlug: string): string => {
  return `/store/${campaignSlug}/login`;
};

export const getStoreCampaignRoute = (campaignSlug: string): string => {
  return `/store/${campaignSlug}`;
};

export const getStoreCheckoutRoute = (campaignSlug: string): string => {
  return `/store/${campaignSlug}/checkout`;
};

export const getStoreOrderRoute = (campaignSlug: string, orderId: string): string => {
  return `/store/${campaignSlug}/orders/${orderId}`;
};
